import Bugsnag from '@bugsnag/js';
import { useApp } from '@pixi/react';
import { useEffect } from 'react';
import { useInstanceId } from '../../context/instance/instanceContext';
import { getCurrentBugsnagSceneType } from '../../utils/bugsnagUtils';
import { getTopWindow } from '../../utils/utils';
function setPixiAppOnWindow(instanceId, app) {
    const topWindow = getTopWindow();
    topWindow.pixiApps = topWindow.pixiApps || [];
    topWindow.pixiApps[instanceId] = app;
}
export function removePixiAppFromWindow(instanceId) {
    const topWindow = getTopWindow();
    if (!topWindow.pixiApps) {
        return;
    }
    delete topWindow.pixiApps[instanceId];
    if (Object.keys(topWindow.pixiApps).length === 0) {
        delete topWindow.pixiApps;
    }
}
export const PixiAppMountHandler = () => {
    const app = useApp();
    const instanceId = useInstanceId();
    useEffect(() => {
        const webGlContextLostHandler = (event) => {
            event.preventDefault();
            const sceneType = getCurrentBugsnagSceneType();
            if (sceneType === 'poker') {
                // only report WebGL context lost if still in poker scene
                Bugsnag.notify(new Error(`Table stage PixiJS WebGL context lost: ${event.statusMessage || 'Unknown error'}`));
            }
        };
        setPixiAppOnWindow(instanceId, app);
        app.view?.addEventListener?.('webglcontextlost', webGlContextLostHandler, false);
        return () => {
            removePixiAppFromWindow(instanceId);
            app.view?.removeEventListener?.('webglcontextlost', webGlContextLostHandler);
        };
    }, [app, instanceId]);
    return null;
};
